import Login from '../components/Login';
export default Login;
